import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import BulkEditAuthorizer from './components/BulkEditAuthorizer';

const AgentsPage = lazy(() => import('./pages/agent-bulk-edit/AgentsPage'));
const routes: RouteObject[] = [
  {
    element: <BulkEditAuthorizer />,
    children: [
      {
        path: '/portal/bulk-edit/agents',
        element: <AgentsPage />
      }
    ]
  }
];

export default routes;
